    import * as React from "react";
import Modal from "react-bootstrap/Modal";
import { DeviceData } from "../models/DeviceData";

interface Props {
    zoom: number;
    devices: Array<DeviceData>;
    closeModal: () => void;
    onInputRedundancyChange: (newRedundant: "NREN" | "REN") => Promise<void>;
    redundancy: string;
}

interface State {
    closeFocus: boolean;
}

export class InputRedundancyModal extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { closeFocus: false }
    }

    handleRedundancyChange = () => {
        // new redundant value can be either NREN or REN. Default to NREN.
        let newRedundant: "NREN" | "REN" = "NREN";
        // if the PF is NREN then switch newRedundant to REN
        if (this.props.redundancy === "NREN") {
            newRedundant = "REN";
        }
        // send new value up and close the modal on return
        this.props.onInputRedundancyChange(newRedundant)
            .then(() => this.props.closeModal());
    }

    onMouseEnter = () => {
        this.setState({
            closeFocus: true
        })
    }

    onMouseLeave = () => {
        this.setState({
            closeFocus: false
        })
    }

    render() {
        const closeModal = this.props.closeModal;
        const redundant = this.props.redundancy && this.props.redundancy.trim() || "NREN";
        var closeClass = this.state.closeFocus ? "ui-dialog-titlebar-close ui-corner-all ui-state-hover" : "ui-dialog-titlebar-close ui-corner-all";


        return (

            <Modal
                show={true}
                animation={false}
                centered={true}
                onEscapeKeyDown={() => closeModal()}
                onHide={() => { /* don't allow hide via off-click*/ }}
                size="lg"
                enforceFocus={true}
                style={{ zIndex: 10001, background: "rgba(000, 000, 000, 0.5)" }}
            >
                <div className="ui-dialog ui-widget ui-widget-content ui-corner-all ui-draggable" tabIndex={-1} role="dialog" aria-labelledby="ui-dialog-title-templatepopup" style={{ display: 'block', zIndex: 1002, outline: '0px', height: 'auto', width: '200px', top: '390px', left: '370px' }}>
                    <div className="ui-dialog-titlebar ui-widget-header ui-corner-all ui-helper-clearfix">
                        <span className="ui-dialog-title" id="ui-dialog-title-templatepopup">Input Votings</span>
                        <div className={closeClass} role="button">
                            <span className="ui-icon ui-icon-closethick" style={{ cursor: "pointer" }} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave} onClick={() => closeModal()}>close</span>
                        </div>
                    </div>
                    <div id="templatepopup" className="ui-dialog-content ui-widget-content" style={{ display: 'block', width: 'auto', minHeight: '0px', height: '132.522px' }} >
                    <div style={{ paddingLeft: '20px', paddingTop: '20px', paddingBottom: '20px' }}>
                        <table>
                            <tbody><tr>
                                <td>
                                    <span id="Label4" style={{ color: 'Black', fontSize: 'Larger', fontWeight: 'bold' }}>1ooN</span>
                                </td>
                                <td style={{ paddingLeft: '10px' }}>
                                        <input id="Check_Reduntant" type="radio" name="Reduntant" value={this.props.redundancy} checked={redundant === "REN"} onChange={this.handleRedundancyChange} />
                                </td>
                            </tr>
                                <tr>
                                    <td style={{ paddingTop: '10px' }}>
                                        <span id="Label6" style={{ color: 'Black', fontSize: 'Larger', fontWeight: 'bold' }}>NooN</span>
                                    </td>
                                    <td style={{ paddingLeft: '10px', paddingTop: '10px' }}>
                                            <input id="Check_NonReduntant" type="radio" name="Reduntant" value={this.props.redundancy} checked={redundant === "NREN"} onChange={this.handleRedundancyChange} />
                                    </td>
                                </tr>
                                </tbody>
                         </table>
                    </div>
                    </div>
                </div>
            </Modal>
        );
    }
}